import React from 'react';

import {Button as InfobarButton,useTheme} from '@mui/material';

import icons from 'assets/icons';

import _ from 'lodash';

const svgIcons = {
    'more': icons.More,
    'back': icons.Back,
    'forward': icons.Forward,
    'new': icons.New,
    'save': icons.Save,
    'burger': icons.Burger
};

const styles = {
    root: {
        cursor: 'pointer',
        justifyContent: 'center',
        alignItems: 'center',

        width: {
            mobile: '18.75%',
            desktop: '7.692307%',
        },
        height: {
            mobile: '50px',
            desktop: '60px',
        }
    },
    fullsizeButton: {
        width: '100%',
        height: {
            mobile: '50px',
            desktop: '60px',
        }
    },
    selected: {
        backgroundColor: 'black.light',
    }
};

const Button = ({color, icon, onClick, fullsize = false, selected = false, disabled = false, ...rest}) => {
    const theme = useTheme();

    const SvgIcon = svgIcons[icon];
    
    return <InfobarButton
        sx={{
            ...styles.root,
            ...(fullsize ? styles.fullsizeButton : {}),
            ...(selected ? styles.selected : {})
        }}
        onClick={onClick}
        disabled={disabled}
        {...rest}
    >
        <SvgIcon style={{
            fill: disabled
                ? theme.palette.grey.light
                : (color ? _.get(theme.palette, color) : theme.palette.white.main),
            display: 'block',
            width:  26,
            height: 26,
        }} />
    </InfobarButton>;
};

export default Button;